import React, { ReactNode } from 'react';
import styled from 'styled-components';
import em from 'polished/lib/helpers/em';
import { FormattedMessage } from 'react-intl';

const BadgeContainer = styled.span`
  display: inline-block;
  width: 6em;
  height: 6em;
  border-radius: 50%;
  background-color: ${props => props.badgeColor || props.theme.highlightColor};
  
  span {
    white-space: nowrap;
    text-transform: uppercase;
    font-family: Flow-Poster-Bold;
    font-size: 2em;
    line-height: ${em(6, 2)};
    color: black;
    &.logo-type {
      font-feature-settings:"liga", "dlig";
    }
  }
  
  &.narrow {
    position: relative;
    left: 0;
    top: 0;
    display: block;
    text-align: center;
    width: 100%;
    height: auto;
    box-sizing: border-box;
    border-radius: 0;
    
    span {
      display: block;
      line-height: 1;
      padding: ${em(1, 2)} ${em(1, 2)};
    }
  }
`;

interface Props {
  type: string;
  content?: string | ReactNode;
  badgeColor?: string;
}

const Badge = ({
  type,
  content,
  badgeColor
}: Props) => {
  const _renderBadgeContent = (type: string): ReactNode => {
    if (type === 'new') {
      return (
        <FormattedMessage id='artists.newBadgeLabel' />
      )
    } else if('partner' && content) {
      return (
        <span className='logo-type'>{content}</span>
      );
    } else {
      return null;
    }
  };

  return (
    <BadgeContainer badgeColor={badgeColor}>
      {_renderBadgeContent(type)}
    </BadgeContainer>
  )
};

export default Badge;


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/ui/Badge.tsx